import { P2GLink, P2GGrid, SvgMapMarker, SvgParcel, SvgLabelPrinting4X6, SvgRefresh } from '@parcel2go/core-ui';
import DropItem from './DropItem';
import { SettingsCache } from '~/lib/consts/settings-cache';
import { EventSections } from '../../../lib/events/EventLogger';
import { useTranslation } from '@parcel2go/npm-p2g-app';
import { GenerateBaseAnalyticsPayload } from '~/lib/utils/analytics';
import { TranslationNamespaces } from '~/lib/constants';
import useSmartSendAnalytics from '~/hooks/use-smartsend-analytics';
import useOnLoad from '~/routes/use-on-load';
import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { ToSmartSendAnalyticsModel } from '../quotes/utils/CurrentSelectionType';

interface props {
  viewDetails: () => void;
  viewActions: () => void;
  viewLabels: () => void;
  viewTracking: () => void;
  arrangeReturn?: () => void;
  direction: 'row' | 'column';
  item: SmartSendItemApiModel;
}

export default function SmartSendItemBookedDrop(props: props) {
  const { track } = useSmartSendAnalytics();
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  useOnLoad(() => {
    track({
      type: 'quick_actions_loaded',
      payload: {
        ...GenerateBaseAnalyticsPayload([
          EventSections.BookedItems,
          EventSections.SmartSendItem,
          EventSections.QuickActions
        ])
      }
    });
  });

  const onClick = (link: string) => {
    track({
      type: 'quick_actions_click',
      payload: {
        ...GenerateBaseAnalyticsPayload([
          EventSections.BookedItems,
          EventSections.SmartSendItem,
          EventSections.QuickActions
        ]),
        action: link,
        items: [ToSmartSendAnalyticsModel(props.item)]
      }
    });
  };

  return (
    <div style={{ width: props.direction === 'row' ? '100%' : '200px' }}>
      <P2GGrid
        container
        spacing={2}
        justify={props.direction === 'row' ? 'center' : 'flex-start'}
        direction={props.direction || 'column'}
      >
        {SettingsCache.settings.Features.includes('Tracking') && (
          <DropItem icon={<SvgMapMarker />} iconSrc="/theme/icons/MapMarker.svg">
            <P2GLink
              onClick={() => {
                onClick('tracking');
                props.viewTracking();
              }}
            >
              {t('SMARTSEND_ITEM_BOOKED_DROP_VIEW_TRACKING', { defaultValue: 'View Tracking' })}
            </P2GLink>
          </DropItem>
        )}
        <DropItem icon={<SvgParcel />} iconSrc="/theme/icons/Parcel.svg">
          <P2GLink
            onClick={() => {
              onClick('details');
              props.viewDetails();
            }}
          >
            {t('SMARTSEND_ITEM_BOOKED_DROP_VIEW_DETAILS', { defaultValue: 'View Details' })}
          </P2GLink>
        </DropItem>
        <DropItem icon={<SvgLabelPrinting4X6 />} iconSrc="/theme/icons/LabelPrinting4X6.svg">
          <P2GLink
            onClick={() => {
              onClick('labels');
              props.viewLabels();
            }}
          >
            {t('SMARTSEND_ITEM_BOOKED_DROP_DOWNLOAD_LABELS', { defaultValue: 'Download Labels' })}
          </P2GLink>
        </DropItem>

        {props.arrangeReturn && (
          <DropItem icon={<SvgRefresh />} iconSrc="/theme/icons/Refresh.svg">
            <P2GLink
              onClick={() => {
                onClick('return-label');
                props.arrangeReturn();
              }}
            >
              {t('SMARTSEND_ITEM_BOOKED_DROP_ARRANGE_RETURN_LABEL', { defaultValue: 'Arrange Return Label' })}
            </P2GLink>
          </DropItem>
        )}
      </P2GGrid>
    </div>
  );
}
